import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createKudos,
  listKudosForUser,
  listKudosCategoryTags,
  listKudosRecipients,
} from '../services/api/respect';

export function useKudosForUser(userId: number) {
  return useQuery({
    queryKey: ['kudos', 'for-user', userId],
    queryFn: () => listKudosForUser(userId),
    enabled: Number.isFinite(userId),
  });
}

export function useKudosCategoryTags() {
  return useQuery({
    queryKey: ['kudos', 'category-tags'],
    queryFn: listKudosCategoryTags,
  });
}

export function useKudosRecipients() {
  return useQuery({
    queryKey: ['kudos', 'recipients'],
    queryFn: listKudosRecipients,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGiveKudos() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createKudos,
    onSuccess: (_kudos, vars) => {
      qc.invalidateQueries({ queryKey: ['kudos', 'for-user', vars.toUserId] });
      qc.invalidateQueries({ queryKey: ['respect', vars.toUserId] });
      qc.invalidateQueries({ queryKey: ['respect', 'spotlight'] });
    },
  });
}
